import { REGEX } from "../constants/regex";
import { StateHandler } from "../util/getStateFun";
import { startLoader, stopLoader } from "../util/loader"
import { LocateAddressBumper } from "../header/locateAddressBumper";
import { getCountryCode } from "../location-search-map/getCountryCode";
import { getBrandDetailsFromBrandJson, getFranchiseDetails, handleCrossDomainLink, weblocationDetailsById } from "../util/share";
import { handleErrorScenario, handleNearbyLocationsFlow } from "../util/common-neaybyLocations";
import { GetLocateLocation } from "../header/GetLocateLocation";

export class MrElectricFormHandler {
  private static instance: MrElectricFormHandler;

  static getInstance(): MrElectricFormHandler {
      if (!MrElectricFormHandler.instance) {
          MrElectricFormHandler.instance = new MrElectricFormHandler();
      }
      return MrElectricFormHandler.instance;
  }

  private form: HTMLFormElement;
  private findSection: HTMLElement;
  private zipCodeInput: HTMLInputElement;
  constructor() {
    this.form = document.querySelector(".find-input-wrapper button") as HTMLFormElement;
    this.findSection = document.querySelector(".find-section") as HTMLElement;
    this.zipCodeInput = document.getElementById('find-local-input') as HTMLInputElement;

    if (localStorage.getItem('weblocationId') && this.findSection) {
      this.findSection.style.display = "none"; // user when local page ready
    }
    // Attach event listener to the form submission
    if (this.form) this.form.addEventListener("click", this.handleSubmit.bind(this));
 
    const radioButtons = document.querySelectorAll('.find-section .glass-type-container .radio-basic');
    radioButtons?.forEach((radio) => {
      radio.addEventListener('change', this.handleServiceTypeChange.bind(this));
    });
    const inputZIpCode = document.getElementById('find-local-input') as HTMLInputElement;
    if(inputZIpCode){

    this.zipCodeInput?.addEventListener('input', this.zipCodeError.bind(this))
  }

  }


  zipCodeError() {
    if (this.zipCodeInput.value != '' && !REGEX.sendZip.test(this.zipCodeInput.value.trim())) {

        const fieldError: any = document.getElementById(`find-local-input-error-msg`);
         fieldError.classList.remove('hidden')

       !fieldError.innerHTML.trim() && (fieldError.innerHTML = 'Invalid zip code format.' )

    }
    else {
      const fieldError: any = document.getElementById(`find-local-input-error-msg`);
      fieldError.classList.add('hidden')
    
  
    }

}


  handleSubmit = (event: Event) => {
    event.preventDefault();
    event.stopPropagation();
    const zipCodeInput = document.getElementById("find-local-input") as HTMLInputElement;
    const zipCode = zipCodeInput.value.trim();
    if (this.validateForm()) {
      startLoader()
      this.getData(zipCode);
    }
  }
  
 
  getData(zipCode: string) {
    const findSection = document.querySelector('.find-section');
    let serviceIdValue: string | undefined; 
    // If find-section exists
    if (findSection) {
      // Find the radio buttons inside that
      const radioButtons = findSection.querySelectorAll('input[type="radio"].radio-basic');
      if (radioButtons.length > 0) {
        radioButtons.forEach((radioButton) => {
          const inputElement = radioButton as HTMLInputElement;
          if (inputElement.checked) {
            // Get the hidden input with the class 'findlocal-service-id'
            const serviceIdInput = radioButton.parentElement?.querySelector('.findlocal-service-id')
            // Check if the input exists and has a value
            if (serviceIdInput && serviceIdInput.classList.contains('findlocal-service-id') && (serviceIdInput as HTMLInputElement).value) {
              serviceIdValue = (serviceIdInput as HTMLInputElement).value;
            sessionStorage.setItem('serviceIdValue', serviceIdValue);
            }
          }
        });
      }
    }

    const submitButton = document.querySelector(".find-input-wrapper button") as HTMLButtonElement;
    submitButton.setAttribute("disabled", "true");
    getFranchiseDetails(zipCode, false, serviceIdValue)
    .then(async(response) => {
        submitButton.disabled = false;
        const result = response;

        if (result.length > 0) {
          sessionStorage.setItem('alternateConcept', result[0].alternateConcept);
          localStorage.setItem("franchiseWebLocationId", result[0].franchiseWebLocationId);
          let countryCode = getCountryCode();
          sessionStorage.setItem('countryCode', countryCode);
          localStorage.setItem('doingBusinessAs', result[0].doingBusinessAs);
          sessionStorage.setItem('franchiseeName', result[0].franchiseeName);
          sessionStorage.setItem('sAddressParam', zipCode)  

          localStorage.setItem("alternateConcept", result[0].alternateConcept);
          localStorage.setItem("franchiseWebLocationId", result[0].franchiseWebLocationId);
          this.findSection.style.display = "none";
          const sRedirectURL = result[0].locationWebsiteUrl ?? "";
          // Set the localStorage item for the Header & Footer logo URL link
          if(sRedirectURL){
            handleCrossDomainLink(sRedirectURL);
          }
          // END 
          const hostURL = new URL(sRedirectURL);
          const hostname = hostURL.host;
          const pathname = hostURL.pathname;         
          const redirectURL = new URL(window.location.href);
          const redirectHostName = redirectURL.host;
          const conceptCode = (document.getElementById('conceptCode') as HTMLInputElement)?.value;
          let crownPeakUrl: boolean = false;
          const brandDetail = await getBrandDetailsFromBrandJson(conceptCode)
              crownPeakUrl = brandDetail?.include_crownpeakURL ?? false;
              if (crownPeakUrl || brandDetail?.include_statename) {
                const weblocation = weblocationDetailsById();
                if (weblocation?.weblocation_url) {
                  window.location.replace(weblocation?.weblocation_url);
                  return
                }
              }
          window.location.replace(`https://${redirectHostName}${pathname}`);
        } else {
          const conceptCode = GetLocateLocation.getInstance().getInputValue('conceptCode');
          getBrandDetailsFromBrandJson(conceptCode)
            .then((brandDetail) => {
              const showNearbyFlag = brandDetail?.show_nearby_location_modal;
              if (showNearbyFlag) {
                handleNearbyLocationsFlow(zipCode);
              }
              else {
                handleErrorScenario(zipCode)
              }
            }).catch((err: any) => {
              console.log('Unable to read brands.json.');
              //  brandDetail fails, handle error too
              handleErrorScenario(zipCode);
            });
        }
        stopLoader()
      })
      .catch(async (error) => {
        stopLoader();
        submitButton.disabled = false;
        const duplicate = error;
        const headerLocalBtn = document.querySelector(".brand-header .find-local") as HTMLElement;
        if (typeof error?.then === 'function') {
          error = await error;
          }
          
          let message = error?.response?.data?.message;
          if(!message){
              message = error?.message;
          } 
          if(!message){
              message = '';
          }
         
      if (message.toLowerCase() === "full address is needed to narrow down results"){
          const stateHandler = new StateHandler();
          stateHandler.getStateFun(); 
          const modalWindow = document.getElementById("glb-find-local");
          const step1 = document.querySelector('.step-1') as HTMLElement;
          const step2 = document.querySelector('.step-2') as HTMLElement;

          if (step1) {
            step1.classList.add('hidden');
          }

          if (step2) {
            step2.classList.remove('hidden');
            step2.classList.add('block');

            const closeLocalModal = document.querySelector('.close-modal-btn');
            closeLocalModal?.addEventListener('click', function handleClick(event) {

            step2.classList.add("hidden");
            step1.classList.remove("hidden");
            })
          }
          headerLocalBtn?.click();
          const modalZipCode = document.querySelector('.step-2 #modal-zipcode') as HTMLInputElement;
          modalZipCode.value = encodeURIComponent(zipCode);

          const locateAddressBumper = new LocateAddressBumper();
        }
      });
  }

  validateForm(): boolean {
    const zipCodeInput = document.getElementById("find-local-input") as HTMLInputElement;
    const zipCode = zipCodeInput.value;
    const formFields = { zipCode };
    const errors: any = {};

  
    if (zipCodeInput.required && formFields.zipCode === '') {
      errors['find-local-input'] = '';
  } else if (zipCodeInput.required && !REGEX.sendZip.test(formFields.zipCode.trim())) {
      errors['find-local-input'] = 'Invalid zip code format.';
  }

  const serviceTypeContainer = document.querySelector('.find-section .glass-type-container') as HTMLElement;
  const serviceTypeRadios = document.querySelectorAll('.find-section .glass-type-container input[name="solution-type"]')as NodeListOf<HTMLInputElement> | null;
  const zipCodeErrorMsg = document.getElementById("find-local-input-error-msg") as HTMLElement;
  let isServiceTypeSelected = false;
  if (serviceTypeRadios && serviceTypeRadios.length > 0) {
      isServiceTypeSelected = Array.from(serviceTypeRadios).some(radio => radio.checked);
  }
    document.querySelectorAll('.error-msg').forEach(e => e.classList.add('hidden'));
    // const fieldmain: any = document.querySelector('form . find-input-wrapper');

    if (serviceTypeContainer?.hasAttribute('required') && !isServiceTypeSelected) {
      if (zipCodeErrorMsg) {
       zipCodeErrorMsg.classList.remove('hidden');
       }
       return false;
     }
    Object.keys(errors).forEach((fieldId, index) => {
      const field: any = document.getElementById(fieldId);
      const fieldError: any = document.getElementById(`${fieldId}-error-msg`);
      if (field && field.parentNode) {
          const errorMessage = errors[fieldId];
          const errorElement = document.createElement('span');
          errorElement.className = 'error-msg';
          errorElement.textContent = errorMessage
          field.classList.add("invalid-field");
          if (fieldError && errorMessage) {
              fieldError.innerHTML = errorMessage
          }
          if (fieldError && fieldError.classList.contains('hidden'))
              fieldError.classList.remove('hidden')
          // field.parentNode.appendChild(errorElement);
      }
      if (index == 0 && field) {
          field.focus()
      }
  });

    return Object.keys(errors).length === 0;
  }
  handleServiceTypeChange() {

    const serviceTypeContainer = document.querySelector('.find-section .glass-type-container') as HTMLElement;
    // If serviceTypeContainer is null, exit early
    if (!serviceTypeContainer) return;
    const serviceTypeRadios = document.querySelectorAll('.find-section .glass-type-container input[name="solution-type"]');
    // Check if serviceTypeRadios is not empty
    if (serviceTypeRadios.length === 0) {
      return;
  }
    let isServiceTypeSelected = Array.from(serviceTypeRadios).some(radio => (radio as HTMLInputElement).checked);
    const zipCodeErrorMsg = document.getElementById("find-local-input-error-msg") as HTMLElement;
  
    // Check if the glass-type-container has the "required" attribute and if a service type is selected
    if (serviceTypeContainer.hasAttribute('required') && !isServiceTypeSelected) {
      if (zipCodeErrorMsg) {
        zipCodeErrorMsg.classList.remove('hidden');
      }
    } else if (zipCodeErrorMsg) {
        zipCodeErrorMsg.classList.add('hidden');
      }
  }
}

// Initialize the class when the DOM content is loaded
document.addEventListener("DOMContentLoaded", () => {
  if ((globalThis as any).__MrElectricFormHandlerInitialized) return;
  (globalThis as any).__MrElectricFormHandlerInitialized = true;
  MrElectricFormHandler.getInstance();
});
